<nz-form-item>
  <nz-form-label translate>payment.paymentDetails.label</nz-form-label>
  <nz-form-control>
    <span class="app-payment-details-label">
      <label nz-checkbox [nzChecked]="isPaymentDetailsStructured" (nzCheckedChange)="onSwitchPaymentDetailsType($event)" translate>
        payment.paymentCode.label
      </label>
    </span>
  </nz-form-control>

  @if (!isPaymentDetailsStructured) {
  <nz-form-control [nzExtra]="'payment.paymentDetails.extra' | translate: locale.language">
    <textarea
      nz-input
      nzSize="large"
      rows="3"
      [maxlength]="config.detailsMaxLength"
      [placeholder]="'payment.paymentDetails.placeholder' | translate: locale.language"
      [formControl]="paymentDetailsControl"
      data-cy="payment-details-textarea"
    ></textarea>
  </nz-form-control>
  } @else {
  <nz-form-control [nzExtra]="'payment.paymentCode.description' | translate: locale.language">
    <input
      nz-input
      nzSize="large"
      type="text"
      [maxlength]="config.paymentCodeMaxLength"
      [placeholder]="'payment.paymentCode.placeholder' | translate: locale.language"
      [formControl]="paymentCodeControl"
    />
  </nz-form-control>
  }
</nz-form-item>
